import Image from 'next/legacy/image';

import { H3, H4 } from '@common/headline';
import { BodyRegular } from '@common/body';

import NHS from '@public/img/our-story/nhs.svg';
import Chris from '@public/img/our-story/chris.png';
import ChrisSignature from '@public/img/our-story/chris-signature.png';
import Mike from '@public/img/our-story/mike.png';
import MikeSignature from '@public/img/our-story/mike-signature.png';

export const WhyWeStarted = (): JSX.Element => (
  <div className="bg-blue px-3 py-16 md:px-[40px] lg:px-[60px] lg:py-[144px]">
    <div className="flex flex-col lg:container lg:m-auto lg:flex-row">
      <div className="mb-6 flex flex-1 items-center lg:mb-0">
        <div className="flex flex-row lg:mr-[80px]">
          <div className="h-[70px] w-[70px] lg:h-[88px] lg:w-[88px]">
            <Image src={Chris} alt="Chris" width={88} height={88} />
          </div>
          <div className="ml-6 hidden text-mono-white lg:block">
            <H4>Chris</H4>
            <Image
              src={ChrisSignature}
              alt="Chris"
              layout="fixed"
              width={127}
              height={54}
            />
          </div>
        </div>
        <div className="ml-[-11px] flex flex-row">
          <div className="h-[70px] w-[70px] lg:h-[88px] lg:w-[88px]">
            <Image src={Mike} alt="Mike" width={88} height={88} />
          </div>
          <div className="ml-6 hidden text-mono-white lg:block">
            <H4>Mike</H4>
            <Image
              src={MikeSignature}
              alt="Mike"
              layout="fixed"
              width={127}
              height={54}
            />
          </div>
        </div>
      </div>
      <div className="mb-8 flex-1 lg:mb-0">
        <div className="mb-4 text-mono-white">
          <H3>
            “We started Second Nature because we were frustrated with the{' '}
            <span className="text-teal">status</span> quo of the{' '}
            <span className="text-teal">weight-loss industry</span>: calorie
            counting, fad diets, and misleading nutrition advice.”
          </H3>
        </div>
        <div className="mb-6 text-mono-white lg:mb-8">
          <BodyRegular>
            We&apos;re both scientists and after researching the latest
            nutritional and behavioural-change science, we knew there was a
            better way: a way to make losing weight feel easier by building
            healthier habits that become Second Nature.
          </BodyRegular>
        </div>
        <div className="h-[29px] w-[126px] lg:h-[43px] lg:w-[190px]">
          <Image src={NHS} alt="Backed by NHS" width={190} height={43} />
        </div>
      </div>
      <div className="flex flex-row lg:hidden">
        <div className="mr-4 text-mono-white">
          <H4>Chris</H4>
          <Image
            src={ChrisSignature}
            alt="Chris"
            layout="fixed"
            width={89}
            height={38}
          />
        </div>
        <div className="text-mono-white">
          <H4>Mike</H4>
          <Image
            src={MikeSignature}
            alt="Mike"
            layout="fixed"
            width={92}
            height={39}
          />
        </div>
      </div>
    </div>
  </div>
);
